import { useEffect, useState } from "react";
import { searchEducationsV2 } from "../../../repository/RealEstateRepository";
import { Navbar } from "../molecule";
import { EducationMap } from "../organism";

const EducationMapPage = (props) => {
  const [educations, setEducations] = useState(null);
  const [mapBounds, setMapBounds] = useState(null);

  useEffect(() => {
    if (!mapBounds) return;
    loadEducations();
    // eslint-disable-next-line
  }, [mapBounds]);

  const onChangeMap = (m) => {
    setMapBounds({
      swLat: m.bounds.getSW().lat(),
      swLng: m.bounds.getSW().lng(),
      neLat: m.bounds.getNE().lat(),
      neLng: m.bounds.getNE().lng(),
      centerLat: m.center.lat(),
      centerLng: m.center.lng()
    });
  };

  const loadEducations = () => {
    const types = ["MIDDLE_SCHOOL", "ELEMENTARY_SCHOOL", "ACADEMY_STREET"];
    searchEducationsV2({ types: types.join(","), ...mapBounds }, (res) => {
      setEducations(res);
    });
  };

  return (<>
    <Navbar pathname={props.location.pathname} />
    <EducationMap
      educations={educations}
      reloadEducations={loadEducations}
      onChangeMap={onChangeMap} />
  </>);
};

export { EducationMapPage };
